<template>
    <transition name="modal">
        <div class="modal__mask modaldeclaracoes" v-if="showModalCreate > 0" style="width: 100% !important;">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">

                        <div class="inner__modal_docs_pj">
                            <div style="display: flex; justify-content: center; width: 100%;">
                                <img style="width: 40px; height: 47px;" src="@/assets/question.png" />
                            </div>
                            <div style="display: flex; justify-content: center; width: 100%;">
                                <h2>Termos de uso</h2>
                            </div>
                            <div class="conteudo-model">
                                <span id="conteudoImpressao" v-html="conteudoTermosFormatado">
                                </span>
                            </div>

                            <div class="buttonsAcoes" :style="bloquearAceite ? 'justify-content: center;' : 'padding-bottom: 0px;'">


                                <div class="row" v-if="bloquearAceite != true && listaAssinantes.length > 1">

                                    <div class="agrupamento-opcoes">
                                        <div style="display: inline-flex">
                                            <span style="color: red; margin-left: 0px;" v-if="erroConfirmar">Necessário aceitar os termos para confirmar adesão ao produto</span>
                                            <span>Selecione abaixo os representantes que deverão assinar o documento: </span>
                                        </div>

                                        <div style="display: inline-flex" @click="abrirModalSaibaMais()">
                                            <div style="color: #00235C; font-size: 12px; font-family: Inter; font-weight: 400; text-decoration: underline; word-wrap: break-word">instruções</div>
                                            <img class="help" src="@/assets/info.png" />
                                        </div>
                                    </div>

                                </div>
                                </div>

                                <div class="agrupamento-opcoes">
                                    <div class="custom-dropdown" style="width: 100%; max-width: 400px; margin-bottom: 5px;">
                                        <div v-if="isOpen" class="dropdown-list-wrapper">
                                            <div class="dropdown-list">
                                                <div v-for="assinante in listaAssinantes" :key="assinante.TipoPessoaGuid" class="dropdown-item">
                                                    <input
                                                    :id="'assinante_' + assinante.TipoPessoaGuid"
                                                    type="checkbox"
                                                    :value="assinante"
                                                    v-model="selectedOptions"
                                                    />
                                                    <label :for="'assinante_' + assinante.TipoPessoaGuid">{{ assinante.TipoPessoaDescricao }} - {{ assinante.Nome }}</label>
                                                    <div>{{assinante.Email}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="dropdown-header" @click="toggleDropdown">
                                            {{ selectedOptions.length }} Selecionado(s)
                                            <span class="setaDrop" :class="{ 'rotate': isOpen }">▼</span>
                                        </div>
                                    </div>


                                




                        </div>

                    <span style="width: 100%; display: flex;
                    justify-content: center; margin-bottom: 5px;" 
                    v-if="this.user.TipoCliente == 'Pessoa Física' && this.existeRepresentante">

                    O assinante é um representante legal.

                    </span>
                        

                    <div class="buttonsAcoesModel" :class="{'is-bloqueado': bloquearAceite}">
                        <div class="agrupamento-botoesModel">
                            <div class="button-row-model">
                                <button v-if="bloquearAceite != true" class="btnBlueModal" @click="confirmar">{{this.user.TipoCliente == 'Pessoa Física' && !this.existeRepresentante ? 'Confirmar' : 'Enviar para assinatura' }}</button>
                                <button v-if="habImpressao" class="btnBlueModal" @click="imprimir">Imprimir</button>
                                <button class="btnDefaultModal" @click="closeModal">Voltar</button>
                            </div>
                        </div>
                    </div>

                    </div>

                </div>
            </div>
        </div>
        <div v-if="requisicaoPendente" class="loading-overlay">
            <div class="spinner"></div>
        </div>
        </div>
    </transition>
   <ModalInformativoSaibaMais :conteudo="conteudoSaibaMais" :titulo="'Como funciona'" />
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';
import ModalInformativoSaibaMais  from '@/views/Cadastro/SaibaMais/ModalInformativoSaibaMais.vue'

export default {
    components: {
         ModalInformativoSaibaMais
    },
    computed: {
        ...mapGetters({
            showModalCreate: 'GET_MODAL_TERMOS_DOCUMENTOS',
            bloquearAceite: 'GET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS',
            listaDocumentosClientes: 'GET_LISTA_DOCUMENTOS_CLIENTE',
            listaAssinantes: 'GET_LISTA_ASSINANTES',
            habImpressao: 'GET_MODAL_TERMOS_DOCUMENTOS_IMPRESSAO',
            user: 'auth/user',
        }),
        existeRepresentante() {
            return this.listaAssinantes?.some(x => x.TipoPessoaDescricao === 'Representante');
        },
        conteudoTermosFormatado() {
        // Adiciona target="_blank" a todas as tags <a>
        return this.conteudoTermos.replace(/<a href/g, '<a target="_blank" href');
        }
    },
    data() {
        return { 
            aceitoTermos: false,
            erroConfirmar: false,
            conteudoTermos: '',
            requisicaoPendente: false,
            conteudoSaibaMais: `Os responsáveis indicados para assinatura, receberão um e-mail,
com a declaração para que mesmo seja assinado. Portanto, uma declaração só será
considerada como assinada, quando todos os indicados assinarem. <br/><br/>

Cada indicado para assinatura, deverá ler e assinar clicando
no comando de assinar que estará disponível no e-mail, sendo este o aceite
formal da declaração.<br/><br/>

O cadastro só será finalizado, quando todos os campos
obrigatórios forem informados e quando as declarações forem assinadas.`,
            isOpen: false,
            selectedOptions: [], // Armazena as opções selecionadas
            options: [
                { label: "Pessoa Jurídica", value: "PJ" },
                { label: "Pessoa Física", value: "PF" },
                { label: "Fundo de Investimento", value: "FU" }
            ]
        }
    },
    watch: {
        listaAssinantes(){
            if(this.listaAssinantes.length == 1){
                this.selectedOptions.push(this.listaAssinantes[0]);
            }
        },
        showModalCreate(){
            this.aceitoTermos = this.bloquearAceite;
            if(this.showModalCreate > 0){
                if(this.listaDocumentosClientes != null && this.listaDocumentosClientes.filter(obj => obj.TemplateId == this.showModalCreate)[0] != null){
                    this.conteudoTermos = this.listaDocumentosClientes.filter(obj => obj.TemplateId == this.showModalCreate)[0]?.Texto;
                }else{
                    this.conteudoTermos = this.listaDocumentos.filter(obj => obj.TemplateId == this.showModalCreate)[0]?.Texto;
                }
            }else{
                this.conteudoTermos = '';
            }
        },
        listaDocumentosClientes(){
            if(this.showModalCreate > 0){
                if(this.listaDocumentosClientes != null && this.listaDocumentosClientes.filter(obj => obj.TemplateId == this.showModalCreate)[0] != null){
                    this.conteudoTermos = this.listaDocumentosClientes.filter(obj => obj.TemplateId == this.showModalCreate)[0]?.Texto;
                }else{
                    this.conteudoTermos = this.listaDocumentos.filter(obj => obj.TemplateId == this.showModalCreate)[0]?.Texto;
                }

            }
        }
    },
    mounted(){
        this.$store.dispatch("FETCH_PJ_LISTA_ASSINANTES");
        this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", false);
    },
    methods: {
    abrirModalSaibaMais(){
               this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", true);
    },
     imprimir() {
      // Pega o conteúdo da div que você deseja imprimir
      const conteudoImpressao = document.getElementById('conteudoImpressao').innerHTML;

      // Cria uma nova janela para impressão
      const janelaImpressao = window.open('', '', 'width=600,height=400');

      // Adiciona o conteúdo e o estilo necessário para impressão
      janelaImpressao.document.write(`
        <html>
          <head>
            <title>Termos de Uso</title>
            <style>
              /* Adicione aqui os estilos que deseja aplicar durante a impressão */
              body {
                font-family: Arial, sans-serif;
              }
              div {
                padding-right: 25px;
                padding-left: 25px;
                overflow: hidden scroll;
              }
            </style>
          </head>
          <body>
            <div>${conteudoImpressao}</div>
          </body>
        </html>
      `);

      // Executa o comando de impressão
      janelaImpressao.document.close(); // Fecha o documento para garantir que tudo seja renderizado
      janelaImpressao.focus(); // Garante que a janela esteja em foco
      janelaImpressao.print(); // Inicia a impressão
      janelaImpressao.close(); // Fecha a janela após a impressão
    },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        closeModal() {
            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
            this.isOpen = false;
            this.erroConfirmar = false;
        },
        async confirmar(){

                    if(!this.existeRepresentante && this.user.TipoCliente == 'Pessoa Física'){
                        await this.confirmarPF();
                        return;
                    }

                    this.isOpen = false;
                    var obj = { TemplateId: this.showModalCreate, Assinantes: this.selectedOptions, Usuario: this.user.NomeRazaoSocial };
                    this.requisicaoPendente = true;

                    await api
                    .post('/declaracao/assinantes', obj )
                    .then((retorno) => {
                            if (retorno.status == 200) {
                                    this.$swal({
                                    icon: 'success',
                                    title: 'Assinatura solicitada',
                                    text: 'Documento foi enviado por e-mail para assinatura',
                                }).then((result) => {
                                    this.requisicaoPendente = false;
                                    if (result.value) {
                                        this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
                                        this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
                                        this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE');
                                    }
                                });
                         
                            }else{
                                this.requisicaoPendente = false;
                                this.$swal({
                                        icon: 'error',
                                        title: 'Oops...',
                                        text: `Falha ao enviar para assinatura`,
                                });
                            }
                    })
                    .catch((error) => {
                                this.requisicaoPendente = false;

                        this.$swal({
                            icon: 'error',
                            title: 'Falha ao vincular assinantes ao documento',
                            text: `${error.response.data.data[0] != null ? error.response.data.data[0] : error.response.data.descricao}`,
                        });
                    });


            
        },
        async getIpAddress() {
            try {
                const response = await fetch("https://api.ipify.org?format=json");
                const data = await response.json();
                return data.ip;
            } catch (error) {
                console.error("Error fetching IP address:", error);
                return null;
            }
        },
        async confirmarPF() {
                var ip = await this.getIpAddress();
                var obj = { DeclaracaoId: 0, TemplateId: this.showModalCreate, UsuarioAssinatura: this.user.NomeRazaoSocial, Status: 'Assinado', DataAssinatura: new Date(), IP: ip };
                this.requisicaoPendente = true;

                const retorno = await api.post('/declaracao/cliente', obj);
                if (retorno.status == 200) {
                    this.$swal({
                        icon: 'success',
                        title: 'Ler os termos',
                        text: 'Termos aceitos com sucesso',
                    }).then((result) => {
                        this.requisicaoPendente = false;
                        if (result.value) {
                            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS", 0);
                            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
                            this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS');
                            this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_CLIENTE');
                        }
                    });

                } else {
                    this.requisicaoPendente = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `Falha ao aceitar os termos`,
                    });
                }


            
        }
    },
};
</script>

<style lang="scss">
@include modal;


.modal__mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 90% !important;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}



@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.subTitle {
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.modaldeclaracoes.modal__mask {
    background-color: rgba(0, 0, 0, 0.7);

    @media (max-width: 768px) {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 0 !important;
    }

    .modal__wrapper {
        @media (max-width: 768px) {
            display: block !important;
            width: 100% !important;
            margin: 0 auto !important;
            vertical-align: middle !important;
        }
    }

    .modal__container.reset {
        @media (max-width: 768px) {
            width: 90% !important;
            height: auto !important;
            max-height: 70vh !important;
            margin: 0 auto !important;
            border-radius: 8px !important;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3) !important;
            position: relative !important;
            transform: scale(0.9) !important;
        }
    }

    .conteudo-model{
        max-height: 320px; 
        min-height: 250px; 
        max-width: 100%;
        padding-right: 25px; 
        padding-left: 25px; 
        overflow: hidden scroll;

        @media (max-height: 768px){
            max-height: 250px; 
            min-height: 150px; 
        }
        
        @media (max-width: 768px) {
            max-height: 170px;
            min-height: 140px;
            max-width: 100%;
            padding: 5px 8px;
            margin: 5px 0;
            border: 1px solid #eee;
            border-radius: 6px;
        }
    }

    img {
        margin-top: 0px !important;
    }

    .modal__wrapper .modal__container.reset {
            width: calc(90% - 40px);
            height: calc(90% - 40px);
            max-height: calc(100% - 40px);
            
            @media (max-width: 768px) {
                width: calc(100% - 40px);
                height: auto !important;
                max-height: 75vh;
                margin: 20px;
                border-radius: 16px;
                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
                padding: 15px;
            }
    }

    .content__modal {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;

        .close__modal {
            position: absolute;
            right: 34px;
            top: 30px;
            font-family: "Montserrat";

            @media (max-width: 768px) {
                top: 16px;
                right: 16px;
            }
        }

        h3 {
            margin-bottom: 46px;

            @media (max-width: 768px) {
                font-size: 24px;
                margin-bottom: 20px;
                text-align: center;
                max-width: 280px;
            }
        }
    }

    .inner__modal_docs_pj {

        margin-top: 40px !important;
        width: 90% !important;
        align-content: center;
        
        @media (max-width: 768px) {
            margin-top: 5px !important;
            padding: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: auto;
            margin-left: auto;
        }

        .custom-dropdown {
            position: relative;
            width: 100%;
            font-family: Arial, sans-serif;
            display: flex;
            flex-direction: column;
        }

        .dropdown-header {
            padding: 10px;
            background-color: #007bff;
            color: white;
            cursor: pointer;
            border-radius: 4px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .dropdown-header span {
            margin-left: 10px;
        }

        .dropdown-header .rotate {
            transform: rotate(180deg);
        }

        .dropdown-list-wrapper {
            position: absolute;
            bottom: 100%;
            left: 0;
            right: 0;
            margin-bottom: 0px;
            z-index: 1000;
        }
        
        .dropdown-list {
            background-color: white;
            border: 1px solid #ccc;
            height: auto;
            max-height: 200px;
            overflow-y: auto;
            width: 100%;
            box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.1);
        }

        .setaDrop{
            color: #FFF;
        }

        .dropdown-item {
            padding: 10px;
            display: flex;
            align-items: center;
        }

        .dropdown-item input {
            margin-right: 10px;
        }

        .dropdown-item label {
            margin-top: 8px;
            display: inline-block;     /* ou block / flex-item */
            max-width: 250px;          /* largura máxima */
            white-space: nowrap;       /* não quebra de linha */
            overflow: hidden;          /* esconde excesso */
            text-overflow: ellipsis;   /* coloca "..." */
            vertical-align: middle;    /* alinha bonito com ícones/botões */
            cursor: pointer;
        }

        h2 {
        margin-bottom: 20px !important;
        }

        span {
            color: #667085;;
            font-family: Inter;
            font-size: 14px;
            font-weight: 400;
        }

        .help {
            width: 18px;
            height: 18px;
            cursor: pointer;
            transform: rotate(5deg);
            margin-left: 10px;
        }

        img {
            margin-left: 0;
        }

    }

}

.titleConta {
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
    font-family: "Work Sans", sans-serif;
}


.buttonsAcoesModel {
  display: flex;
  justify-content: center;     /* default */
  margin-top: 5px;
  width: 100%;
}

/* quando bloquearAceite = true, centraliza */
.buttonsAcoesModel.is-bloqueado {
  justify-content: center;
  padding-bottom: 30px;
  margin-top: 0;    
}

.agrupamento-botoesModel {
  width: 100%;
  display: flex;
  justify-content: center;       /* centraliza o bloco dos botões */
}

.agrupamento-opcoes {
    display: flex;
    justify-content: center !important; /* centraliza na horizontal */
    align-items: center !important;     /* centraliza na vertical */
    gap: 8px;                /* espaço entre os itens (opcional) */
    margin-top: 5px;
    width: 100%;
}

.button-row-model {
  display: flex;
  gap: 10px;                     /* ESPAÇO ENTRE BOTÕES */
  width: 100%;
  max-width: 400px;              /* opcional: limite de largura */
}

.button-row-model button {
  flex: 1;                       /* divide igualmente o espaço */
  min-width: 0;                  /* evita estourar linha por texto longo */
  height: 40px;
  font-family: "Inter", sans-serif;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  padding: 5px 8px;
  font-size: smaller;
  /* width:auto não é necessário quando usa flex:1 */
}

/* estilos dos botões */
.btnBlueModal {
  padding: 2em 2em;
  background-color: #00235c;
  color: #fff;
  border: 1px solid #00235c;
  /* 'widows' é uma propriedade tipográfica; remova */
}

.btnDefaultModal {
  background-color: #fff;
  color: #344054;
  border: 1px solid #d0d5dd;
  /* remova a margem lateral para não quebrar o gap */
  margin-right: 0;
}



</style>
